import loading from './loading';
import errorLog from './errorLog';
import tagsView from './tagsView';
import schoolYear from './schoolYear';
import app from './app';
import user from './user';
import msg from './msg';
import globalConfig from './globalConfig';

export default {
  loading,
  errorLog,
  tagsView,
  app,
  schoolYear,
  user,
  msg,
  globalConfig
};
